import { render, staticRenderFns } from "./StockWeightTime.vue?vue&type=template&id=454a459b&scoped=true&"
import script from "./StockWeightTime.vue?vue&type=script&lang=js&"
export * from "./StockWeightTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a459b",
  null
  
)

export default component.exports